import { Field } from "../../../models/workshop/common"

export const fillSettings = (initialSettings: Field[], applicationSettings: Field[]): Field[] => {
    if (applicationSettings.length === 0) {
        return initialSettings
    }

    const settingsMap = new Map(applicationSettings.map(setting => [setting.Id, setting]))

    return initialSettings.map(initialSetting => {
        const applicationSetting = settingsMap.get(initialSetting.Id)
        return applicationSetting ? { ...initialSetting, Value: applicationSetting.Value } : initialSetting
    })
}
